import React, { useEffect, useState, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useUser, useTemplate } from 'components/hooks';
import { ROUTES } from 'consts'
import { formatProjectItems, jobType, levelDetail, notificationType, pollingType } from 'helpers';
import { withRouter, useHistory } from 'react-router-dom';
import withRequest from 'hoc/withRequest';
import { TemplateSchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import TemplateFormViewDumb from "./TemplateFormViewDumb";

const TemplateViewSmart = (props) => {
  const { match: { params } } = props;
  const { templateId } = params;
  const { parameters } = useUser();
  const history = useHistory();
  const { cleanUpMessage, cleanUp, error, success, putTemplate, getTemplate, data, isLoaded } = useTemplate();
  const [loadedData, setLoadedData] = useState(false)
  const projects = formatProjectItems(parameters);

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    description: '',
    jobType: jobType[0].value,
    project: projects[0].value,
    inventory: '',
    credential: 0,
    forks: 0,
    limit: 0,
    levelDetail: levelDetail[0].value,
    timeout: 0,
    commandLine: '',
    showChanges: false,
    consultExecution: false,
    enabledPrivileges: false,
    enabledJobs: false,
    useCache: false,
    additionalVariables: '',

    playbook: '',
    tagsJob: [],
    tagsSkip: [],
    tags: [],

    notificationType: notificationType[0].value,
    userProject: '',
    notifications: [],

    pollingType: pollingType[0].value,
    pollings: [],
  });

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const template = new TemplateSchema().formatRequest(data);
    // template.formatRequest(data); template.formatRequest no existe
    putTemplate({ body: template });
  };

  useEffect(() => {
    if (!!success.put) history.push(ROUTES.TEMPLATE_LIST);
    else if (!!success.get) handleData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.put, success.get]);

  useLayoutEffect(() => {
    cleanUp();
    getTemplate({ query: { templateId: templateId } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleData() {
    const template = new TemplateSchema(data[0]).formatResponse();
    setDefaultValues({ ...defaultValues, ...template });
    setLoadedData(true);
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data && projects && loadedData) ?
        (
          <TemplateFormViewDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true}
          />
        )
        :(
          <></>
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="templateCreate.components.alert.error" />
    </>
  );
};

export default withRequest(withRouter(TemplateViewSmart));
